import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {user} from '@enigma/core/services';
import Stylesheet from './Register.module.css';
import {UserContext} from '../../contexts/user';
import Input from '../../elements/Input/Input';
import { ico_user,
    ico_surpries, ico_laugh_squint, 
    ico_exclamation_triangle, 
    ico_user_tie, ico_user_secret, 
    ico_user_lock, ico_key, ico_check, ico_database } from '../../icon';
import {AppContext} from '../../contexts/app';
import Email from '../../elements/Email/Email';
import Password from '../../elements/Password/Password';
import Button from '../../elements/Button/Button';
import DropMenu from '../../elements/DropMenu/DropMenu';

const Register = (props) => {
    // update window title
    document.title = 'Registration';
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [otherName, setOtherName] = useState(null);
    const [role, setRole] = useState(null);
    const [branch, setBranch] = useState(null);
    const [authKey, setAuthKey] = useState(null);
    const [basic, setBasic] = useState(null);
    const [loading, setLoading] = useState(null);
    const [complete, setComplete] = useState(false);
    let app = null;
    const init = (appContext) => {app = appContext};

    const signUp = async profile => {
        setLoading(true);
        // validate autherziation key
        const isAuthorized = await user
        .verifyAuthorizationKey(authKey);
        if (!isAuthorized) {
            app.toggleToast(ico_key, 
            'authorization key invalid', true);
            setLoading(false);
            return null;
        }
        // create user with custome details
        await user.createCustom(email, password, profile, false);
        // upload profile image (if cover image was not set) and sign in user
        await user.setProfile({profileImg: 'users/default/profile.png'});
        // set user display name 
        await user.updateDisplayName(profile.displayName);
        //logout user and redirect to login page
        user.signOut();
        app.toggleToast(ico_check, "registration complete, you may login now");
        setComplete(true);
    }

    const validatePersonalDetails = _ => {
        // validate required fields
        if (!firstName || firstName === '') {
            app.toggleToast(ico_exclamation_triangle, 
            'please enter your first name', true);
            return;
        }
        if (!lastName || lastName === '') {
            app.toggleToast(ico_exclamation_triangle, 
            'please enter your last name', true);
            return;
        }
        if (!role || role === '') {
            app.toggleToast(ico_exclamation_triangle, 
            'please select your role', true);
            return;
        }
        if (!branch || branch === '') {
            app.toggleToast(ico_exclamation_triangle, 
            'please select your primary branch', true);
            return;
        }
        // validations passed
        const current = {};
        current.firstName = firstName.toLowerCase();
        current.lastName = lastName.toLowerCase();
        current.otherName = otherName?.toLowerCase() || null;
        current.branch = branch;
        current.role = role;
        current.displayName = firstName+' '+lastName;
        current.email = email;
        current.timestamp = Date.now();
        // complete registration
        signUp(current);
    }

    const personalAccountDetails = () => {
        /* render personal account customization */
        return (
            <form className={Stylesheet.Form} onSubmit={event => {
                event.preventDefault();
                validatePersonalDetails();
            }}>
                <h5 className={Stylesheet.Subtitle}>finish setting up your profile</h5>                
                <div className={Stylesheet.Field}>
                    <Input icon={ico_user} type='text' 
                    defaultValue={firstName}
                    onChange={value => setFirstName(value)}
                    placeholder='your first name' />
                </div>
                <div className={Stylesheet.Field}>
                    <Input icon={ico_user_tie} type='text' 
                    defaultValue={lastName}
                    onChange={value => setLastName(value)}
                    placeholder='your last name' />
                </div>
                <div className={Stylesheet.Field}>
                    <Input icon={ico_user_secret} type='text' 
                    defaultValue={otherName}
                    onChange={value => setOtherName(value)}
                    placeholder='other names' />
                </div>
                <div className={Stylesheet.Field}>
                    <DropMenu default='select your role' values={[
                        "administration",
                        "branch manager",
                        "IT support",
                        "data entry clerk",
                        "audit officer"
                    ]}
                    onChange={value => setRole(value)} />
                </div>
                <div className={Stylesheet.Field}>
                    <DropMenu default='select your location' values={[
                        "suva", 
                        "nadi",
                        "lautoka",
                        "sigatoka",
                        "ba",
                        "tavua",
                        "Rakiraki",
                        "labasa"
                    ]}
                    onChange={value => setBranch(value)} />
                </div>
                <small className={Stylesheet.Small}>
                by registering you agree to follow all terms and policies
                set forth by the <i>fleet managment console</i>.
                </small> 
                <div className={Stylesheet.Controls}>
                    <div className={Stylesheet.Control}>
                        <Button type='button' onClick={_ => 
                        setBasic(null)}>back</Button>
                    </div>
                    <div className={Stylesheet.Control}>
                        <Button loading={loading} 
                        secondary type='submit'>finish</Button>
                    </div>
                </div>
            </form>
        )
    }
    // validation methods for each sign up level
    const validateBasicProfile = async _ => {
        // check email validation state
        if (!email || email === '') {
            app.toggleToast(ico_surpries, 
            'email is required', true);
            return null;
        }
        // check if password has been entered
        if (!password || password === '') {
            app.toggleToast(ico_laugh_squint, 
            'password is required', true);
            return null;
        }
        // check authorization key
        if (!authKey || authKey === '') {
            app.toggleToast(ico_surpries, 
            'authorization key is required', true);
            return null;
        }
        // check if email is available for sign up
        if (!(await user.isEmailAvailable(email))) {
            app.toggleToast(ico_exclamation_triangle, 
            'the email address is already in use.', true);
            return null;
        }
        // custome user profile data
        setEmail(email);
        setPassword(password);
        setBasic(true);
    }

    const basicProfile = () => {
        /* render sign up form */
        return (
            <form className={Stylesheet.Form} onSubmit={event => {
                event.preventDefault();
                validateBasicProfile() }}>
                <h6 className={Stylesheet.Subtitle}>
                account registration, enter basic account information</h6>
                <div className={Stylesheet.Field}>
                    <Email icon defaultValue={email} 
                    domain='gmgroup.com.fj'
                    onChange={value => setEmail(value)} />
                </div>
                <div className={Stylesheet.Field}>
                    <Password icon defaultValue={password} 
                    onChange={value => setPassword(value)} />
                </div>
                <div className={Stylesheet.Field}>
                    <Input icon={ico_user_lock} defaultValue={authKey} 
                    placeholder='authorization key'
                    onChange={value => setAuthKey(value)} />
                </div>
                <div className={Stylesheet.Controls}>
                    <div className={Stylesheet.Control}>
                        <Button secondary type="submit">next</Button>
                    </div>
                </div>
            </form>
        )
    }

    const forms = () => {
        if (!basic) return basicProfile();
        return personalAccountDetails();
    }

    const signup = () => {
        return (
            <div className={Stylesheet.Signup}>      
                <div className={Stylesheet.Logo}>
                    <h1>{ico_database}</h1>
                </div>
                <h3 className={Stylesheet.Title}>
                fleet managment console</h3>
                {forms()}
                <h5 className={Stylesheet.Login}>
                already have an account?, 
                &nbsp;<Link to="/login">login</Link></h5>
            </div>
        )

    }

    return (
        <UserContext.Consumer>
            {user => (
                <AppContext.Consumer>
                    {app => (
                        <div className={Stylesheet.Container}>
                            {complete ? <Redirect to='/login' /> : null}
                            {init(app)}
                            {signup()}
                            <h6 className={Stylesheet.Copyright}>
                            &copy;enigmasoftworks 2021.
                            &nbsp;<span>all</span> rights reserved.</h6>
                        </div>
                    )}
                </AppContext.Consumer>
            )}
        </UserContext.Consumer>
    )
}

export default Register;